var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoudspeaker = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.5H5L9 0.5V10.5L5 8.5H4L5 11.5H3L2 8.5H0V3.5ZM1 4.5H5.33333L8 2.5V8.88197L5.23607 7.5H1V4.5Z",
    fill: "#32373E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.99995C12 4.75368 11.41 3.64596 10.2236 3.05273L9.77637 3.94716C10.5899 4.35394 11 5.09276 11 5.99995C11 6.51554 10.8908 6.92228 10.6965 7.24533C10.5029 7.56718 10.2055 7.83817 9.77637 8.05273L10.2236 8.94716C10.7945 8.66172 11.247 8.27018 11.5534 7.76076C11.8591 7.25255 12 6.65928 12 5.99995Z",
    fill: "#32373E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoudspeaker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loudspeaker.acf001db157b56c3492a8e527fef9726.svg";